module.exports = __webpack_public_path__ + "static/media/bg.c7f304a2.png";